import React from 'react'
import { Routes, Route } from 'react-router-dom'
import AddBugfixProject from '../AddBugfixProject'
import BugfixProjectList from '../BugfixProjectList'

function Main() {
  return (
    <main>
      <Routes>
        <Route path='/' element={<BugfixProjectList />} />
        <Route path='/bugfix/add' element={<AddBugfixProject />} />
      </Routes>
    </main>
  )
}

export default Main
